"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastWrapper = exports.ToastIcon = exports.ToastContent = exports.ToastClose = exports.Toast = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _animations = require("../styles/animations");
var _IconButton = require("../Buttons/IconButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ToastWrapper = _styledComponents.default.div`
    animation: ${_animations.fadeIn} 0.2s ease-in;
    transition: opacity 0.2s ease-out;
    opacity: ${props => props.visible ? 1 : 0};
`;
exports.ToastWrapper = ToastWrapper;
const Toast = _styledComponents.default.div`
    display: flex;
    align-items: flex-start;
    max-width: 360px;
    padding: 5px 10px;

    background-color: var(--grey8);
    color: white;

    border: 1px solid rgba(var(--black-rgb), 0.1);
    border-radius: 10px;

    justify-content: space-between;
    overflow: hidden;

    a {
        color: white;
    }
`;
exports.Toast = Toast;
const ToastIcon = _styledComponents.default.div`
    width: 32px;
    height: 32px;
    flex-shrink: 0;
`;
exports.ToastIcon = ToastIcon;
const ToastContent = _styledComponents.default.div`
    margin: 6px 0;
    flex: 1;
    padding: 0 10px;
`;
exports.ToastContent = ToastContent;
const ToastClose = (0, _styledComponents.default)(_IconButton.IconButton)`
    font-size: 24px;
`;
exports.ToastClose = ToastClose;